// Large Countries/Continents dropdown
const navbarTravelDropdownToggle = document.getElementById('navbarTravelDropdownToggle');
const navbarTravelDropdownMenu = document.getElementById('navbarTravelDropdownMenu');
toggleDropdown(navbarTravelDropdownToggle, navbarTravelDropdownMenu);

// Airports
const navbarAirportsDropdownToggle = document.getElementById('navbarAirportsDropdownToggle');
const navbarAirportsDropdownMenu = document.getElementById('navbarAirportsDropdownMenu');
toggleDropdown(navbarAirportsDropdownToggle, navbarAirportsDropdownMenu);

// Airports Mobile
const navbarAirportsDropdownToggleMobile = document.getElementById('navbarAirportsDropdownToggleMobile');
const navbarAirportsDropdownMenuMobile = document.getElementById('navbarAirportsDropdownMenuMobile');
toggleDropdown(navbarAirportsDropdownToggleMobile, navbarAirportsDropdownMenuMobile);

// Info
const navbarInfoDropdownToggle = document.getElementById('navbarInfoDropdownToggle');
const navbarInfoDropdownMenu = document.getElementById('navbarInfoDropdownMenu');
toggleDropdown(navbarInfoDropdownToggle, navbarInfoDropdownMenu);

// Info Mobile
const navbarInfoDropdownToggleMobile = document.getElementById('navbarInfoDropdownToggleMobile');
const navbarInfoDropdownMenuMobile = document.getElementById('navbarInfoDropdownMenuMobile');
toggleDropdown(navbarInfoDropdownToggleMobile, navbarInfoDropdownMenuMobile);

// Travel Mobile
const navbarTravelDropdownToggleMobile = document.getElementById('navbarTravelDropdownToggleMobile');
const navbarTravelDropdownMenuMobile = document.getElementById('navbarTravelDropdownMenuMobile');
toggleDropdown(navbarTravelDropdownToggleMobile, navbarTravelDropdownMenuMobile);

// TravelType
const navbarTravelTypeDropdownToggle = document.getElementById('navbarTravelTypeDropdownToggle');
const navbarTravelTypeDropdownMenu = document.getElementById('navbarTravelTypeDropdownMenu');
toggleDropdown(navbarTravelTypeDropdownToggle, navbarTravelTypeDropdownMenu);

// TravelType Mobile
const navbarTravelTypeDropdownToggleMobile = document.getElementById('navbarTravelTypeDropdownToggleMobile');
const navbarTravelTypeDropdownMenuMobile = document.getElementById('navbarTravelTypeDropdownMenuMobile');
toggleDropdown(navbarTravelTypeDropdownToggleMobile, navbarTravelTypeDropdownMenuMobile);


// Collapse windows when clicking outside
window.addEventListener('click', function (e) {
    if (e.target !== navbarTravelDropdownMenu && !navbarTravelDropdownMenu.contains(e.target)) {
        if (e.target !== navbarTravelDropdownToggle && !navbarTravelDropdownToggle.contains(e.target)) {
            if (!navbarTravelDropdownToggle.classList.contains('collapsed')) {
                navbarTravelDropdownToggle.classList.add('collapsed');
                navbarTravelDropdownMenu.classList.add('collapsed');
            }
        }
    }

    if (e.target !== navbarTravelTypeDropdownMenu && !navbarTravelTypeDropdownMenu.contains(e.target)) {
        if (e.target !== navbarTravelTypeDropdownToggle && !navbarTravelTypeDropdownToggle.contains(e.target)) {
            if (!navbarTravelTypeDropdownToggle.classList.contains('collapsed')) {
                navbarTravelTypeDropdownToggle.classList.add('collapsed');
                navbarTravelTypeDropdownMenu.classList.add('collapsed');
            }
        }
    }

    if (e.target !== navbarAirportsDropdownMenu && !navbarAirportsDropdownMenu.contains(e.target)) {
        if (e.target !== navbarAirportsDropdownMenu && !navbarAirportsDropdownToggle.contains(e.target)) {
            if (!navbarAirportsDropdownToggle.classList.contains('collapsed')) {
                navbarAirportsDropdownToggle.classList.add('collapsed');
                navbarAirportsDropdownMenu.classList.add('collapsed');
            }
        }
    }

    if (e.target !== navbarInfoDropdownMenu && !navbarInfoDropdownMenu.contains(e.target)) {
        if (e.target !== navbarInfoDropdownMenu && !navbarInfoDropdownToggle.contains(e.target)) {
            if (!navbarInfoDropdownToggle.classList.contains('collapsed')) {
                navbarInfoDropdownToggle.classList.add('collapsed');
                navbarInfoDropdownMenu.classList.add('collapsed');
            }
        }
    }
});

function toggleDropdown(toggle, menu) {
    if (toggle && menu) {
        toggle.addEventListener('click', function (e) {
            if (e.target == toggle && toggle.classList.contains('collapsed')) {
                setTimeout(function () {
                    toggle.classList.toggle('collapsed');
                    menu.classList.toggle('collapsed');
                }, 50);
            }

            collapseAll();
        });
    }
}

function collapseAll() {
    navbarTravelDropdownToggle.classList.add('collapsed');
    navbarTravelDropdownMenu.classList.add('collapsed');

    navbarAirportsDropdownToggle.classList.add('collapsed');
    navbarAirportsDropdownMenu.classList.add('collapsed');

    navbarAirportsDropdownToggleMobile.classList.add('collapsed');
    navbarAirportsDropdownMenuMobile.classList.add('collapsed');

    navbarInfoDropdownToggle.classList.add('collapsed');
    navbarInfoDropdownMenu.classList.add('collapsed');

    navbarInfoDropdownToggleMobile.classList.add('collapsed');
    navbarInfoDropdownMenuMobile.classList.add('collapsed');

    navbarTravelTypeDropdownToggle.classList.add('collapsed');
    navbarTravelTypeDropdownMenu.classList.add('collapsed');

    navbarTravelTypeDropdownToggleMobile.classList.add('collapsed');
    navbarTravelTypeDropdownMenuMobile.classList.add('collapsed');

    navbarTravelDropdownToggleMobile.classList.add('collapsed');
    navbarTravelDropdownMenuMobile.classList.add('collapsed');
}
